import { useAxiosClient } from '../';

export const useTagApi = () => {
    const { axiosClient } = useAxiosClient();

    return {
        tagsList: async () => (await axiosClient.get(`/v1/tag/all-user-areas`)).data,
        tagsByUserList: async () => (await axiosClient.get(`/v1/tag/user-area`)).data,
    }
}